import mapActions from './mapActions';

export default mapActions('working_hours_types', {
    fetchAll_url: () => '/api/working_hours/types'
});
